export const DP_PORTAL_PATH = '/departamento-pessoal';
export const DP_REQUESTS_PATH = `${DP_PORTAL_PATH}/solicitacoes`;
export const DATA_UPDATE_PATH = `${DP_REQUESTS_PATH}/dados`;
export const TICKET_PATH = `${DP_REQUESTS_PATH}/outros`;
export const DAY_OFF_PATH = `${DP_REQUESTS_PATH}/day-off`;
export const OVERTIME_PATH = `${DP_REQUESTS_PATH}/hora-extra`;
export const RARO_INVEST_PATH = `${DP_REQUESTS_PATH}/raro-invest`;
export const HEALTH_PLAN_PATH = `${DP_REQUESTS_PATH}/beneficios`;
export const DP_ATTENDANCE_PATH = `${DP_PORTAL_PATH}/atendimentos`;
export const DP_APPROVALS_PATH = `${DP_PORTAL_PATH}/aprovacoes`;
